// Dropdown field from the events designs (Figma 791:18510): the same surface as an
// .input with a keyboard_arrow_down chevron. A native <select> underneath keeps the
// phone's own picker and keyboard support.
export default function SelectField({ id, value, onChange, label, className = '', children, ...rest }) {
  return (
    <div className={`select-field ${className}`.trim()}>
      <select
        id={id}
        className="select-field__select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={label}
        {...rest}
      >
        {children}
      </select>
      <span className="material-symbols-rounded select-field__icon" aria-hidden="true">keyboard_arrow_down</span>
    </div>
  );
}
